var pug = require("!../../../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (JSON) {var obj = JSON.parse(locals.FinalUrlJson.replace(/&quot;/g, "\"").replace(/(\\u0026|&)/g, "&amp;"));
if (obj.IsFinal) {
if (obj.URL && obj.URL !== "") {
if (locals.DisableSuffix) {
pug_html = pug_html + "\u003Cdiv class=\"control-label\"\u003E" + (pug.escape(null == (pug_interp = obj.URL) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"control-label\"\u003E" + (pug.escape(null == (pug_interp = locals.i18n.getString('FinalUrl_Suffix', obj.URL)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
}
if (obj.MobileFinalURL && obj.MobileFinalURL != "") {
if (locals.DisableSuffix) {
pug_html = pug_html + "\u003Cdiv class=\"control-label\"\u003E" + (pug.escape(null == (pug_interp = obj.MobileFinalURL) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"control-label\"\u003E" + (pug.escape(null == (pug_interp = locals.i18n.getString('MobileFinalUrl_Suffix', obj.MobileFinalURL)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
}
}
else
if (obj.URL != null && obj.URL != "") {
if (locals.DisableSuffix) {
pug_html = pug_html + "\u003Cdiv class=\"control-label\"\u003E" + (pug.escape(null == (pug_interp = obj.URL) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"control-label\"\u003E" + (pug.escape(null == (pug_interp = locals.i18n.getString('DestinationUrl_Suffix', obj.URL)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
}
else {
pug_html = pug_html + "\u003Cdiv class=\"control-label\"\u003E\u003C\u002Fdiv\u003E";
}}.call(this,"JSON" in locals_for_with?locals_for_with.JSON:typeof JSON!=="undefined"?JSON:undefined));;return pug_html;};
module.exports = template;